import { useAtomValue } from 'jotai'
import React from 'react'

import { surveyGroupIdAtom } from '../../atoms'

export const useSurveyGroupFiltersQueryKey = () => {
  const surveyGroupId = useAtomValue(surveyGroupIdAtom)

  return React.useMemo(
    () => [
      'SurveyGroupFilterInformation_SurveyGroupFilters',
      { surveyGroupId },
    ],
    [surveyGroupId],
  )
}
